import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Upload, message, Card, List, Typography } from 'antd';
import { UploadOutlined, FileOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import CustomerMainLayout from '../CustomerMainLayout';
import './BrandGuidelines.scss';

const { Title, Text } = Typography;

const BrandGuidelines = () => {
  // Dummy data for uploaded files
  const [fileList, setFileList] = useState([
    {
      id: 1,
      name: 'Brand_Colors_Guide.pdf',
      size: '2.4 MB',
      uploadDate: '2024-12-15',
      type: 'PDF'
    },
    {
      id: 2,
      name: 'Logo_Usage_Guidelines.pdf',
      size: '1.8 MB',
      uploadDate: '2024-12-10',
      type: 'PDF'
    },
    {
      id: 3,
      name: 'Typography_Standards.docx',
      size: '890 KB',
      uploadDate: '2024-12-05',
      type: 'DOCX'
    },
    {
      id: 4,
      name: 'Brand_Voice_Guide.pdf',
      size: '3.2 MB',
      uploadDate: '2024-11-28',
      type: 'PDF'
    }
  ]);

  const [uploading, setUploading] = useState(false);

  // Handle file upload
  const handleUpload = (file) => {
    setUploading(true);

    // Simulate upload process
    setTimeout(() => {
      const newFile = {
        id: fileList.length + 1,
        name: file.name,
        size: `${(file.size / 1024 / 1024).toFixed(2)} MB`,
        uploadDate: new Date().toISOString().split('T')[0],
        type: file.name.split('.').pop().toUpperCase()
      };

      setFileList([newFile, ...fileList]);
      message.success(`${file.name} uploaded successfully`);
      setUploading(false);
    }, 1000);

    // Prevent default upload behavior
    return false;
  };

  // Handle file delete
  const handleDelete = (fileId) => {
    setFileList(fileList.filter(file => file.id !== fileId));
    message.success('File deleted successfully');
  };

  // Handle file download (dummy)
  const handleDownload = (fileName) => {
    message.info(`Downloading ${fileName}...`);
  };

  const uploadProps = {
    beforeUpload: handleUpload,
    showUploadList: false,
    accept: '.pdf,.doc,.docx,.zip,.jpg,.jpeg,.png',
    multiple: false
  };

  return (
    <CustomerMainLayout selected='37'>
      <div className="brand-guidelines-container">
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="page-header">
              <Title level={2} className="manrope">Brand Guidelines</Title>
              <Text className="manrope f-14 black-33">
                Upload and manage your brand guidelines
              </Text>
            </div>
          </Col>

          <Col span={24}>
            <Card className="upload-card">
              <Row gutter={[16, 16]} align="middle">
                <Col>
                  <Upload {...uploadProps}>
                    <Button
                      type="primary"
                      icon={<UploadOutlined />}
                      loading={uploading}
                      size="large"
                      className="upload-button"
                    >
                      {uploading ? 'Uploading...' : 'Upload'}
                    </Button>
                  </Upload>
                </Col>
                <Col>
                  <Text className="manrope f-14 black-33">
                    Supported formats: PDF, DOC, DOCX, ZIP, JPG, PNG
                  </Text>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col span={24}>
            <Card
              title={
                <span className="manrope f-16 w-600">
                  Uploaded Files ({fileList.length})
                </span>
              }
              className="files-card"
            >
              <List
                dataSource={fileList}
                locale={{ emptyText: 'No files uploaded yet' }}
                renderItem={(file) => (
                  <List.Item
                    key={file.id}
                    className="file-list-item"
                    actions={[
                      <Button
                        type="text"
                        icon={<DownloadOutlined />}
                        onClick={() => handleDownload(file.name)}
                        className="action-button"
                      >
                        Download
                      </Button>,
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(file.id)}
                        className="action-button"
                      >
                        Delete
                      </Button>
                    ]}
                  >
                    <List.Item.Meta
                      avatar={
                        <div className="file-icon">
                          <FileOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
                        </div>
                      }
                      title={
                        <span className="manrope f-14 w-600">{file.name}</span>
                      }
                      description={
                        <div className="file-details">
                          <span className="manrope f-12 black-33">
                            {file.type} • {file.size} • Uploaded on {file.uploadDate}
                          </span>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </CustomerMainLayout>
  );
};

export default withRouter(BrandGuidelines);
